import { render, staticRenderFns } from "./IndexSchedules.vue?vue&type=template&id=5c566604&lang=pug&"
import script from "./IndexSchedules.vue?vue&type=script&lang=js&"
export * from "./IndexSchedules.vue?vue&type=script&lang=js&"
import style0 from "./IndexSchedules.vue?vue&type=style&index=0&id=5c566604&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports